import { COUNTRY_CODES } from "./countries";

const IDENTITY_DOCUMENTS = {
  [COUNTRY_CODES.ECUADOR]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      regex: /^\d{10}$/,
      message: "La cédula debe tener exactamente 10 dígitos numéricos",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      regex: /^\d{13}$/,
      message: "El RUC debe tener exactamente 13 dígitos numéricos",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      regex: /^[A-Za-z0-9]{6,20}$/,
      message: "El pasaporte debe ser alfanumérico entre 6 y 20 caracteres",
    },
  },
  [COUNTRY_CODES.PARAGUAY]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      regex: /^[A-Za-z0-9-]{6,20}$/,
      message: "El documento debe tener entre 6 y 20 cáracteres",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      regex: /^[A-Za-z0-9\-]{8,20}$/,
      message: "El documento debe tener entre 8 y 20 cáracteres",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      regex: /^[A-Za-z0-9-]{9,20}$/,
      message: "El documento debe tener entre 9 y 20 cáracteres",
    },
  }
};

export const getIdentityDocument = (country) => { return (IDENTITY_DOCUMENTS[country] || IDENTITY_DOCUMENTS[COUNTRY_CODES.ECUADOR]); };
